import React, { Fragment, useState, useEffect } from 'react';
import Header from '../../components/header/Header';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import q4 from '../../images/school-activity/4.webp'
import q5 from '../../images/school-activity/5.webp'
import q0 from '../../images/school-activity/10.webp'

// New images imports
import img11 from '../../images/school-activity/11.webp'
import img12 from '../../images/school-activity/12.webp'
import img13 from '../../images/school-activity/13.webp'
import img14 from '../../images/school-activity/14.webp'
import img15 from '../../images/school-activity/15.webp'
import img16 from '../../images/school-activity/16.webp'
import img17 from '../../images/school-activity/17.webp'
import img18 from '../../images/school-activity/18.webp'

import metadataJSON from "../../data/metadata.json";
import schemadataJSON from "../../data/schemadata.json";
import { Helmet } from 'react-helmet';

const SchoolActivity = ({ path }) => {

    // Setting metadata and schemadata 
    const [metadata, setMetadata] = useState({title: "JJFIndia | Our Initiative"});
    const [schemadata, setSchemadata] = useState({});
    
    // Getting the schemadata and setting the schema data. 
    useEffect(() => {
        let tempMetadata = metadataJSON[path];
        let tempSchemadata = schemadataJSON[path];

        if(tempMetadata){
        setMetadata(tempMetadata);
        }else {
        tempMetadata = {
            title: "JJFIndia | Gallery",
            description: "JJFIndia Gallery page",
            keywords: "",
            robots: "index, follow",
            canonical: "https://jjfindia.com/gallery/tree-plantation",
            openGraph: {
                title: "JJFIndia | Gallery",
                description: "JJFIndia Gallery page",
                url: "https://jjfindia.com/gallery/tree-plantation"
            },
            twitter: {
                card: "summary_large_image",
                title: "JJFIndia | Gallery",
                description: "JJFIndia Gallery page"
            }
        }

        setMetadata(tempMetadata);
        }

        // setting schema data 
        if(tempSchemadata) {
            setSchemadata(tempSchemadata);
        }

    }, [path]);

    return (
        <>
            <Helmet>
                {/* Basic Meta Tags */}
                <title>{metadata.title}</title>
                <meta name="description" content={metadata.description} />
                <meta name="keywords" content={metadata.keywords} />
                <meta name="robots" content={metadata.robots} />
        
                {/* Canonical URL */}
                <link rel="canonical" href={metadata.canonical} />
        
                {/* Open Graph */}
                <meta property="og:title" content={metadata.openGraph?.title} />
                <meta property="og:description" content={metadata.openGraph?.description} />
                <meta property="og:url" content={metadata.canonical} />
        
                {/* Twitter Cards */}
                {/* <meta name="twitter:card" content={metadata.twitter?.card} /> */}
                <meta name="twitter:title" content={metadata.twitter?.title} />
                <meta name="twitter:description" content={metadata.twitter?.description} />
                
                {/* Setting up schema data */}
                <script  type="application/ld+json" >{JSON.stringify(schemadata, null, 2)}</script>
            </Helmet>

            <Fragment>
                <Header hclass={'header--styleFour'} />
                <main className="page_content">
                    <PageTitle pageTitle={'School and College Outreach'} pagesub={'Gallery'} />

            
                    <section className="blog pt-60">
                        <div className="container">
                            <div className="row align-items-end">
                                <div className="col-12">
                                    <div className="sectionTitle mb-40" id='feature'>
                                        <span className="sectionTitle__small justify-content-center">
                                            <i className="fa-solid fa-heart btn__icon"></i>School and College Outreach
                                        </span>
                                        <h1 className="sectionTitle__big text-center">School and College Outreach</h1>
                                        <p className='text-center' style={{ fontSize: '24px' }}>Glimpses of our engaging activities to inspire and educate young minds.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="row">

                                {/* <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-40">
                                        <figure className="blogBlock__figure">
                                            {/* <Link to="#" */}
                                            {/* onClick={(e) => e.preventDefault()} className="blogBlock__figure__link"> 
                                            <img src={q1} alt="Stronger Together" className="blogBlock__figure__image" />
                                            {/* </Link> 
                                        </figure>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-60">
                                        <figure className="blogBlock__figure">
                                            <img src={q2} alt="Stronger Together" className="blogBlock__figure__image" />
                                        </figure>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-60">
                                        <figure className="blogBlock__figure">
                                            <img src={q3} alt="Stronger Together" className="blogBlock__figure__image" />
                                        </figure>
                                    </div>
                                </div> */}
                                {/* New Photos */}
                                
                                <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-60">
                                        <figure className="blogBlock__figure">
                                            <img src={img11} alt="Volunteers interacting with students during an outreach session." className="blogBlock__figure__image" />
                                        </figure>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-60">
                                        <figure className="blogBlock__figure">
                                            <img src={img12} alt="Large student gathering during a school outreach event" className="blogBlock__figure__image" />
                                        </figure>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-60">
                                        <figure className="blogBlock__figure">
                                            <img src={img13} alt="Students seated on the ground attending an awareness program" className="blogBlock__figure__image" />
                                        </figure>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-60">
                                        <figure className="blogBlock__figure">
                                            <img src={img14} width={400} loading='lazy' alt="Packed hall of students participating in an outreach session." className="blogBlock__figure__image" />
                                        </figure>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-60">
                                        <figure className="blogBlock__figure">
                                            <img src={img15} width={400} loading='lazy' alt="Students raising hands during an interactive outreach activity" className="blogBlock__figure__image" />
                                        </figure>
                                    </div>
                                </div>
                                
                                <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-60">
                                        <figure className="blogBlock__figure">
                                            <img src={img16} width={400} loading='lazy' alt="Students gathered in a large hall for a school awareness event." className="blogBlock__figure__image" />
                                        </figure>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-60">
                                        <figure className="blogBlock__figure">
                                            <img src={img17} width={400} loading='lazy' alt="Group of students in red uniforms attending the outreach program." className="blogBlock__figure__image" />
                                        </figure>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-60">
                                        <figure className="blogBlock__figure">
                                            <img src={img18} width={400} loading='lazy' alt="Students participating in an activity during the outreach session." className="blogBlock__figure__image" />
                                        </figure>
                                    </div>
                                </div>
                                {/* Old Photos */}
                                <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-60">
                                        <figure className="blogBlock__figure">
                                            <img src={q4} width={400} loading='lazy' alt="Volunteer addressing a large group of students in an auditorium" className="blogBlock__figure__image" />
                                        </figure>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-60">
                                        <figure className="blogBlock__figure">
                                            <img src={q5} width={400} loading='lazy' alt="Volunteer speaking to students during an outreach event." className="blogBlock__figure__image" />
                                        </figure>
                                    </div>
                                </div>

                                {/* <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-60">
                                        <figure className="blogBlock__figure">
                                            <img src={q6} alt="Stronger Together" className="blogBlock__figure__image" />
                                        </figure>
                                    </div>
                                </div> */}
                                {/* <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-60">
                                        <figure className="blogBlock__figure">
                                            <img src={q7} alt="Stronger Together" className="blogBlock__figure__image" />
                                        </figure>
                                    </div>
                                </div> */}
                                {/* <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-60">
                                        <figure className="blogBlock__figure">
                                            <img src={q8} alt="Stronger Together" className="blogBlock__figure__image" />
                                        </figure>
                                    </div>
                                </div> */}
                                {/* <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-60">
                                        <figure className="blogBlock__figure">
                                            <img src={q9} alt="Stronger Together" className="blogBlock__figure__image" />
                                        </figure>
                                    </div>
                                </div> */}
                                <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-60">
                                        <figure className="blogBlock__figure">
                                            <img src={q0} width={400} loading='lazy' alt="Team interacting with students on stage during the outreach session." className="blogBlock__figure__image" />
                                        </figure>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                </main>
                <Footer />
                <Scrollbar />
            </Fragment>
        </>
    )
};

export default SchoolActivity;
